import { React, useState, useEffect } from 'react';
import style from './../adminSect.module.scss';
import { CustomButton } from './../../utils/Utils';
import Table from './Table';
import axios from './../../../config/apiConfig';
import { DatePicker, Space } from 'antd';
import exportFromJSON from 'export-from-json';
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';

const SellsTable = () => {
  // table data
  const [ordersData, setOrdersData] = useState([]);

  // filter
  const [dateFilter, setDateFilter] = useState();

  // useful data
  const [page, setPage] = useState(1);
  const [givenPage, setGivenPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [status, setStatus] = useState(false);
  const [noOrdersFound, setNoOrdersFound] = useState(false);

  const { RangePicker } = DatePicker;

  const {
    sectHeader,
    usersTableHeader,
    headerTitle,
    headerHelpers,
    fullVH
  } = style;

  const getOrders = async ( ) => {
    try {
      setOrdersData([]);
      setStatus(false);
      const reqParams = dateFilter ? `/orders?page=${page}&dateSince=${dateFilter[0]}&dateTo=${dateFilter[1]}` : `/orders?page=${page}`;
      const { data } = await axios.get(reqParams);
      setGivenPage(data.data[0].page);
      setTotalPages(data.data[0].totalPages);
      setOrdersData(data.data[0].orders);
      setStatus(data.status);
    } catch (error) {
      setNoOrdersFound(true);
      console.log(error); // eslint-disable-line
    }
  };

  const getOrdersForExport = async ( ) => {
    try {
      const reqParams = dateFilter ? `/orders/export?dateSince=${dateFilter[0]}&dateTo=${dateFilter[1]}` : '/orders/export';
      const { data } = await axios.get(reqParams);
      return data.data;
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    if (givenPage !== page || dateFilter || dateFilter === false) {
      getOrders();
    }
  }, [dateFilter, page]);

  const toggleModal = (set, state) => {
    set(!state);
  };

  function onChange(value) {
    if (value) {
      setDateFilter([value[0].format('YYYY-MM-DD'), value[1].format('YYYY-MM-DD')]);
      setPage(1);
    } else {
      setDateFilter(false);
    }
  }

  const exportJson = async () => {
    const data = await getOrdersForExport();
    const exportType = exportFromJSON.types.csv;
    const delimiter = ';';
    const since = dateFilter ? dateFilter[0] : null;
    const to = dateFilter ? dateFilter[1] : null;
    const fileName = since && to ? `TablaVentas-${since}__${to}` : 'TablaVentas';
    const withBOM = true;
    exportFromJSON({ data, fileName, exportType, delimiter, withBOM });
  };

  function disabledDate(current) {
    return current && current > moment().endOf('day');
  }


  return (
    <div className={fullVH}>
      <div className={`${sectHeader} ${usersTableHeader}`}>
        <div className={headerTitle}>
          <h1>
            <b>Compras</b>
          </h1>
        </div>
        <div className={`${headerHelpers}`}>
          <CustomButton 
            color="btnPrimary"
            content="EXPORTAR TABLA"
            size="bg"
            onclick={() => exportJson()}
          />
          <Space direction="vertical" size={12}>
            <div className="admin_sells_range">
              <RangePicker
                disabledDate={disabledDate}
                format="DD-MM-YYYY"
                onChange={onChange}
                locale={locale}
              />
            </div>
          </Space>
        </div>
      </div>

      <Table
        toggleModal={toggleModal} 
        orders={ordersData}
        setPage={setPage}
        page={page}
        totalPages={totalPages}
        status={status}
        setNoOrdersFound={setNoOrdersFound}
        noOrdersFound={noOrdersFound}
      />
    </div>
  );
};

export default SellsTable;
